// Creator profile — the feed/site identity + viewer look. Persisted to
// localStorage per Google sub. Captured at first publish and editable
// from Settings; reused by every publish so the site header + theme stay
// stable.

import { DEFAULT_THEME, DEFAULT_ACCENT } from "./themes";

export interface SavedProfile {
  displayName: string;
  bio: string;
  /** Viewer theme id + accent colour (lib/themes.ts). */
  theme?: string;
  accent?: string;
  /** Optional longer about-page markdown. */
  about?: string;
}

function key(sub: string): string { return `bka/profile/${sub}`; }

export function getProfile(sub: string): SavedProfile | null {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(key(sub));
    return raw ? (JSON.parse(raw) as SavedProfile) : null;
  } catch { return null; }
}

export function setProfile(sub: string, p: SavedProfile): void {
  if (typeof localStorage === "undefined") return;
  try { localStorage.setItem(key(sub), JSON.stringify(p)); } catch { /* ignore */ }
}

/** Profile with theme/accent defaults filled in. */
export function profileWithDefaults(p: SavedProfile | null): SavedProfile {
  return {
    displayName: p?.displayName ?? "",
    bio: p?.bio ?? "",
    theme: p?.theme || DEFAULT_THEME,
    accent: p?.accent || DEFAULT_ACCENT,
    about: p?.about ?? "",
  };
}
